const PROMPT_KEYS = {
    HOTEL_DESCRIPTION: 'HOTEL_DESCRIPTION',
};

export default PROMPT_KEYS;
